/* ======================================================================== */
/* 15. PJAX Update Header Classes */
/* ======================================================================== */
function PJAXUpdateHeaderClasses(data) {

	return new Promise(function (resolve, reject) {

		var
			regexp = /\<header.*\sclass=["'](.+?)["'].*\>/gi,
			match = regexp.exec(data.next.html);

		if (!match || !match[1]) {
			return;
		}

		document.querySelector('header').setAttribute('class', match[1]);

		resolve(true);

	});

}
